import { useCallback, useState } from 'react'
import type { MarkerSelectionData } from 'tripPlanner/components/Chat/chatMapConstants'

export type RightPanelView = 'map' | 'itinerary'

interface UseRightPanelStateReturn {
  rightPanelView: RightPanelView
  setRightPanelView: React.Dispatch<React.SetStateAction<RightPanelView>>
  selectedDayItineraryId: number | undefined
  setSelectedDayItineraryId: React.Dispatch<React.SetStateAction<number | undefined>>
  selectedMarkerData: MarkerSelectionData | null
  setSelectedMarkerData: React.Dispatch<React.SetStateAction<MarkerSelectionData | null>>
  handleViewMapToggle: () => void
  handleViewItineraryToggle: () => void
  handleMarkerSelect: (data: MarkerSelectionData | null) => void
  handleMarkerOverlayClose: () => void
}

export function useRightPanelState(): UseRightPanelStateReturn {
  const [rightPanelView, setRightPanelView] = useState<RightPanelView>('itinerary')
  const [selectedDayItineraryId, setSelectedDayItineraryId] = useState<number | undefined>(undefined)
  const [selectedMarkerData, setSelectedMarkerData] = useState<MarkerSelectionData | null>(null)

  const handleViewMapToggle = useCallback(() => {
    setRightPanelView('map')
  }, [])

  const handleViewItineraryToggle = useCallback(() => {
    setRightPanelView('itinerary')
  }, [])

  const handleMarkerSelect = useCallback((data: MarkerSelectionData | null) => {
    setSelectedMarkerData(data)
  }, [])

  const handleMarkerOverlayClose = useCallback(() => {
    setSelectedMarkerData(null)
  }, [])

  return {
    rightPanelView,
    setRightPanelView,
    selectedDayItineraryId,
    setSelectedDayItineraryId,
    selectedMarkerData,
    setSelectedMarkerData,
    handleViewMapToggle,
    handleViewItineraryToggle,
    handleMarkerSelect,
    handleMarkerOverlayClose,
  }
}
